import { createSelector } from 'reselect';

const getDialogs = state => state.dialogs;

export const getCurrentOpenDialog = createSelector(
  getDialogs,
  dialogs => dialogs.currentOpenDialog
);

export const getIsHelpDialogOpen = createSelector(
  getCurrentOpenDialog,
  currentOpenDialog => currentOpenDialog === 'help'
);



// WEBPACK FOOTER //
// ./src/store/dialogs/selectors.js